import React, { useReducer, useEffect, useContext } from "react";
import moduleConfig from "./moduleConfig";
import { Card, Row, Col } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import ModuleHeader from "../../UI/modules/views/partials/common/ModuleHeader";
import {
  createReducer,
  createInitialState,
} from "../../../reducers/module/createReducer";
import { BreadcrumbContext } from "../../../contexts/BreadcrumbContext";
import DashboardLayout from "../../UI/layouts/DashboardLayout";
import FormErrorMessage from "../../UI/errorMessages/FormErrorMessage";
import CMSFormInput from "../../UI/forms/CMSFormInput";
import BlockErrorMessage from "../../UI/errorMessages/BlockErrorMessage";
import CMSFormSelect from "../../UI/forms/CMSFormSelect";
import CMSFormRichText from "../../UI/forms/CMSFormRichText";
import CMSFormImage from "../../UI/forms/CMSFormImage";
import { onSubmitGeneral } from "../../../helpers/ModuleHelperFunctions";
import CMSFormColor from "../../UI/forms/CMSFormColor";

const HomePageSliderCreate = () => {
  const [createState, createDispatch] = useReducer(
    createReducer,
    createInitialState
  );
  const { setBreadcrumb } = useContext(BreadcrumbContext);
  let navigate = useNavigate();

  useEffect(() => {
    setBreadcrumb([
      moduleConfig.breadcrumbs.listing,
      moduleConfig.breadcrumbs.create,
    ]);
  }, []);

  return (
    <DashboardLayout>
      {createState.status === "fetchFailed" ? (
        <BlockErrorMessage error={createState.error} />
      ) : (
        <>
          {/* {console.log(createState.data)} */}
          {createState.status !== "fetching" && (
            <>
              <ModuleHeader
                moduleTitle={`Create ${moduleConfig.singleItemTitle}`}
                moduleUrl={moduleConfig.url}
              ></ModuleHeader>

              <section className="content">
                <Card>
                  <Card.Body>
                    {createState.isLoading && (
                      <div className="overlay position-absolute containerLoading">
                        <i className="fas fa-2x fa-sync-alt fa-spin"></i>
                      </div>
                    )}
                    <Formik
                      initialValues={{
                        backgroundColor: "#cfd4cd",
                        heading: "",
                        headingColor: "#31160d",
                        buttonText: "",
                        buttonTextColor: "#ffffff",
                        buttonLink: "",
                        file: "",
                        buttonColor: "#295b24",
                        sortOrder: "",
                        status: "0",
                      }}
                      validationSchema={yup.object({
                        backgroundColor: yup
                          .string()
                          .required("Background color is required."),

                        heading: yup
                          .string()
                          .required("Heading is required.")
                          .max(50, "Heading cannot exceed 50 characters."),

                        headingColor: yup
                          .string()
                          .required("Heading color is required."),

                        buttonText: yup
                          .string()
                          .required("Button text is required."),

                        buttonTextColor: yup
                          .string()
                          .required("Button text color is required."),

                        buttonLink: yup
                          .string()
                          .required("Button link is required.")
                          .url("Please enter a valid URL."),

                        buttonColor: yup
                          .string()
                          .required("Button color is required."),

                        file: yup
                          .mixed()
                          .required("Please upload an image.")
                          .imageTypeCheck(
                            moduleConfig.imageRequirement.allowedExtensions
                          )
                          .imageSizeCheck(moduleConfig.imageRequirement.size),

                        sortOrder: yup
                          .number()
                          .typeError("Sort order must be a number.")
                          .required("Sort order is required."),

                        status: yup.string().required("Status is required."),
                      })}
                      enableReinitialize={true}
                      validateOnChange={true}
                      validateOnBlur={true}
                      onSubmit={async (values, { resetForm }) => {
                        const formData = new FormData();
                        for (let name in values) {
                          if (Array.isArray(values[name])) {
                            formData.append(name, JSON.stringify(values[name]));
                          } else {
                            formData.append(name, values[name]);
                          }
                        }
                        await onSubmitGeneral(
                          formData,
                          moduleConfig.url,
                          moduleConfig.url,
                          createDispatch,
                          navigate
                        );
                      }}
                    >
                      {(form) => (
                        <Form onSubmit={form.handleSubmit}>
                          {createState.error && (
                            <FormErrorMessage error={createState.error} />
                          )}

                          {/* {console.log(form.errors)} */}

                          <CMSFormColor
                            name="backgroundColor"
                            label="Background Color"
                            required={true}
                            form={form}
                          />

                          <CMSFormInput
                            name="heading"
                            label="Heading"
                             info="Recommended 30 characters"
                            required={true}
                            form={form}
                          />

                          <CMSFormColor
                            name="headingColor"
                            label="Heading Color"
                            required={true}
                            form={form}
                          />

                          <CMSFormInput
                            name="buttonText"
                            label="Button Text"
                            required={true}
                            form={form}
                          />

                          <CMSFormColor
                            name="buttonTextColor"
                            label="Button Text Color"
                           required={true}
                            form={form}
                          />

                          <CMSFormInput
                            name="buttonLink"
                            label="Button Link"
                            required={true}
                            form={form}
                          />

                          <CMSFormColor
                            name="buttonColor"
                            label="Button Color"
                          required={true}
                            form={form}
                          />

                          <CMSFormImage
                            label="Image"
                            name="file"
                            info="Recommended dimensions 800*600"
                            form={form}
                            required={true}
                          />

                          <CMSFormInput
                            name="sortOrder"
                            label="Sort Order"
                            form={form}
                            required={true}
                          />

                          <CMSFormSelect
                            name="status"
                            label="Status"
                            required={true}
                            form={form}
                            options={[
                              { label: "Select Status...", value: "" },
                              { label: "Enabled", value: "1" },
                              { label: "Disabled", value: "0" },
                            ]}
                          />

                          <button
                            type="submit"
                            onClick={() => form.handleSubmit}
                            className="btn btn-primary"
                          >
                            Submit
                          </button>
                        </Form>
                      )}
                    </Formik>
                  </Card.Body>
                </Card>
              </section>
            </>
          )}
        </>
      )}
    </DashboardLayout>
  );
};

export default HomePageSliderCreate;
